<script>

import EmployeeForm from "@/components/users/EmployeeForm.vue";

export default {
    components: {EmployeeForm}
}

</script>
<template>
    <div class="trainings-create">

        <trainer-form :user="{company_id: null}"/>

    </div>
</template>
